import { Component, inject, signal } from '@angular/core';
import { SwiperDirective } from '../../../shared/directive/swiper.directive';
import { SliderService } from '../Services/slider.service';
import { SliderModel } from '../Model/slider.model';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../shared/Module/shared.module';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-slider',
  imports: [SwiperDirective, CommonModule, TranslateModule, SharedModule],
  templateUrl: './slider.component.html',
  styleUrl: './slider.component.css'
})
export class SliderComponent {

  sliders = signal<SliderModel[]>([]);
  private subs = new Subscription();   // container for all subscriptions


  private sliderService = inject(SliderService);

  ngOnInit(): void {
    this.loadSliders();
  }

  public swiperOptions = signal({
    slidesPerView: 1,
    spaceBetween: 20,
    slidesPerGroup: 1,
    speed: 1500,
    loop: true,
    loopFillGroupWithBlank: true,
    centeredSlides: false,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
    },
    preloadImages: true,
    observer: true,
    observeParents: true,

  });

  loadSliders(): void {
    const sub = this.sliderService.getAll().subscribe({
      next: (data) => {
        this.sliders.set(data.value);
        setTimeout(() => {
          const swiperEl = document.querySelector('.banner-one') as HTMLElement;
          if (swiperEl && (swiperEl as any).swiper) {
            (swiperEl as any).swiper.update();
          }
        }, 100);
      },
      error: (err) => {
        console.error('Error loading sliders:', err);
      }
    });
    this.subs.add(sub);
  }

  goToLink(link: string) {
    if (link) {
      window.open(link, '_blank');
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();   // unsubscribe from all
  }
}
